<template>
  <div class="formgrid grid mb-1 ml-1 justify-content-between">
    <div class="flex">
      <SelectButton
        v-model="form"
        :options="Object.values(forms)"
        aria-labelledby="basic"
        class="component-form"
        @click="onChangeForms"
      />
      <MultiSelect
        v-show="form === forms.WELL"
        v-model="currentColumns"
        class="ml-1 component-form "
        placeholder=""
        :options="columnsWell"
        option-label="header"
        option-value="fieldHeader"
        append-to="body"
        @change="changeColumn($event)"
      >
        <template #value>
          Колонки
        </template>
      </MultiSelect>
    </div>
    <Button
      label="Экспорт Excel"
      icon="pi pi-file-excel"
      severity="success"
      class="mr-3 component-form "
      @click="onExportExcel"
    />
  </div>
  <DataTable
    :key="tableKeyMonitoring"
    ref="DataTableMonitoring"
    v-model:filters="currentFilters"
    :value="properMonitoring"
    class="p-datatable-sm p-datatable-gridlines"
    responsive-layout="scroll"
    auto-layout
    :row-class="rowClass"
    scroll-height="780px"
    scrollable
    filter-display="row"
    :virtual-scroller-options="{ itemSize: 25 }"
  >
    <template #empty>
      Записи не найдены.
    </template>
    <template #loading>
      Записи загружаются. Пожалуйста подождите.
    </template>
    <ColumnGroup
      v-if="headerRowsTemp"
      type="header"
    >
      <HeaderRow
        v-for="(row, rowIndex) in headerRowsTemp"
        :key="'row_' + rowIndex"
      >
        <Column
          v-for="(col, colIndex) in row"
          :key="'col_' + rowIndex + '_' + colIndex"
          :header="col.header"
          :rowspan="col.rowspan"
          :colspan="col.colspan"
          :sortable="col.sortable"
          :field="col.field"
        />
      </HeaderRow>
    </ColumnGroup>
    <Column
      v-for="col of columnsTemp"
      :key="col.field"
      :sortable="col.sortable"
      :field="col.field"
      :header="col.header"
      :filter-function="col.filterData ? col.filterData.funcName : null"
      :header-style="col.headerStyle"
      :body-style="col.bodyStyle"
      :show-filter-menu="false"
    >
      <template
        v-if="col.dataType && col.dataType.type == 'Dropdown'"
        #body="slotProps"
      >
        {{
          getFieldName(
            reference[col.dataType.options],
            slotProps.data[col.field],
            col.dataType.value ? col.dataType.value : col.field,
            col.dataType.label ? col.dataType.label : col.field
          )
        }}
      </template>
      <template
        v-else-if="col.dataType && col.dataType.type == 'Link'"
        #body="slotProps"
      >
        <a
          href=""
          style="color: #1921b1"
          @click.prevent="col.link(slotProps.data, col)"
        >
          {{ slotProps.data[col.field] }}
        </a>
      </template>
      <template
        v-else-if="col.dataType && col.dataType.type == 'Checkbox'"
        #body="slotProps"
      >
        <i
          :class="slotProps.data[col.field] ? 'pi  pi-check' : ''"
          :style="slotProps.data[col.field] ? { color: col.color ? col.color : 'green' } : ''"
        />
      </template>
      <template
        v-else
        #body="slotProps"
      >
        <div
          v-if="col.tooltip"
          v-tooltip.left="slotProps.data[col.tooltip]"
        >
          {{ slotProps.data[col.field] }}
        </div>
        <div
          v-else
          :style="getCellStyle(col, slotProps.data)"
        >
          {{ slotProps.data[col.field] }}
        </div>
      </template>
      <template
        v-if="col.filterData"
        #filter="{ filterModel, filterCallback }"
      >
        <component
          :is="col.filterData.type"
          :key="'filter_' + col.field"
          v-model="filterModel.value"
          :v-if="currentFilters[col.field]"
          show-clear
          :placeholder="col.filterData.placeholder ? col.filterData.placeholder : '...'"
          :options="reference[col.filterData.options]"
          :option-label="col.filterData.label ? col.filterData.label : col.field"
          :option-value="col.filterData.value ? col.filterData.value : col.field"
          v-bind="col.filterData.attrList"
          append-to="body"
          :style="{
            width: '100%',
            'max-width': col.filterData['max-width']
              ? col.filterData['max-width']
              : '100%',
          }"
          @change="filterCallback()"
          @input="filterCallback()"
        />
      </template>
    </Column>
  </DataTable>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { WELL_COLUMNS, KOGS_COLUMNS, KOGS_DETAILS_COLUMNS, DGNU_COLUMNS, MFN_COLUMNS, KOGS_DETAILS_HEADER } from './columns';
import { exportExcel } from '@/core/utils/ExportExcel';
import { useRefLoader } from 'cdisoft-library';
import axios from 'axios';

const store = useStore();
const router = useRouter();
const { reference, getFieldName, fillSelfReference } = useRefLoader();

const password = computed(() => store.getters.password);
const info = computed(() => store.getters.info);
const user = computed(() => store.getters.user);
const monitoring = computed(() => store.getters.monitoring);
const monitoringUpdate = computed(() => store.getters.monitoringUpdate);
const struct = computed(() => store.getters.struct);
const server = computed(() => store.getters.server);
const typeFormat = computed(() => store.getters.typeFormat);

function setMonitoring(data) {
  store.dispatch('setMonitoring', data);
}

function addScriptLog(data) {
  store.dispatch('addScriptLog', data);
}

function prepareFacilityLink(facilityId, facilityName) {
  let result = null;
  const id = facilityId ?? facilityName;
  const key = facilityId ? 'facility_id' : 'facility_name';
  for (const element of struct.value) {
    if (id === element[key]) {
      result = {
        node_type_id: element.node_type_id,
        facility_id: element.facility_id,
        facility_type_id: element.facility_type_id,
      };
    }
  }
  return result;
}

function onClickFacilityLink(row) {
  let params = prepareFacilityLink(row.facilityId, row.facilityName);
  params = params ? params : row.link;
  openNewTab(params);
}

function onClickWellLink(row) {
  let params = row.link;
  openNewTab(params);
}

function openNewTab(params) {
  if (!params)
    store.commit('SET_ERROR', {
      er: 'Объект не найден в структуре',
      source: ['TTMAllFacilitiesForm', 'link'],
    });
  const route = router.resolve({
    name: 'form',
    params,
  });
  window.open(route.href, '_blank');
}

const form = ref(null);
const forms = { WELL: 'ГЗУ/БГ/Скв', KOGS: 'КОГС', KOGS_DETAILS: 'КОГС инфо', DGNU: 'ДГНУ', MFN: 'МФН' };
const api = 'kron.tm3.service-web-1.0/webresources/restservice/monitoring/';
const apiMonitoring = ref('kron.tm3.service-web-1.0/webresources/restservice/monitoring/GMB_BG_Well');
const intervalLoadMonitoring = ref(null);
const currentFilters = ref({});
const currentColumns = ref([]);
const columnsTemp = ref([]);
const headerRowsTemp = ref(null);
const tableKeyMonitoringCount = ref(0);
const tableKeyMonitoring = ref(new Date());
const DataTableMonitoring = ref(null);

const columnsWell = ref(WELL_COLUMNS.map(col => ({
  ...col,
  link: col.link ? (row) => col.link(row, { onClickFacilityLink, onClickWellLink }) : undefined,
})));
const columnsKOGS = ref(KOGS_COLUMNS.map(col => ({
  ...col,
  link: col.link ? (row) => col.link(row, { onClickFacilityLink }) : undefined,
})));
const columnsKOGS_DETAILS = ref(KOGS_DETAILS_COLUMNS.map(col => ({
  ...col,
  link: col.link ? (row) => col.link(row, { onClickFacilityLink }) : undefined,
})));
const columnsDGNU = ref(DGNU_COLUMNS.map(col => ({
  ...col,
  link: col.link ? (row) => col.link(row, { onClickFacilityLink }) : undefined,
})));
const columnsMFN = ref(MFN_COLUMNS.map(col => ({
  ...col,
  link: col.link ? (row) => col.link(row, { onClickFacilityLink }) : undefined,
})));
function prepareColumnsTemp() {
  switch (form.value) {
    case forms.WELL:
      getValues(api + 'GMB_BG_Well');
      return columnsWell.value.filter((item) => item.visible);
    case forms.KOGS:
      getValues(api + 'KOGS');
      return columnsKOGS.value.filter((item) => item.visible);
    case forms.KOGS_DETAILS:
      getValues(api + 'KOGS-details');
      return columnsKOGS_DETAILS.value.filter((item) => item.visible);
    case forms.DGNU:
      getValues(api + 'DGNY');
      return columnsDGNU.value.filter((item) => item.visible);
    case forms.MFN:
      getValues(api + 'MFN');
      return columnsMFN.value.filter((item) => item.visible);
    default:
      return [];
  }
}

function prepareHeaderRowsTemp() {
  switch (form.value) {
    case forms.KOGS_DETAILS:
      return KOGS_DETAILS_HEADER;
    default:
      return null;
  }
}

function prepareFilters() {
  let currentFiltersObj = {};
  for (const column of columnsTemp.value) {
    if (column.filterData) {
      currentFiltersObj[column.field] = {
        value: null,
        matchMode: column.filterData.mode ? column.filterData.mode : 'contains',
      };
    }
  }
  currentFilters.value = currentFiltersObj;
}
function getValues(apiParam) {
  if (apiParam) apiMonitoring.value = apiParam;
  const headers = {
    Authorization: 'Basic ' + btoa(info.value.login + ':' + password.value),
    'Content-Type': 'application/zip',
  };
  const apiMonitoringUrl = server.value('TM_MIDDLE') + apiMonitoring.value;
  axios
    .get(apiMonitoringUrl, { headers })
    .then((response) => {
      if (apiMonitoringUrl === server.value('TM_MIDDLE') + apiMonitoring.value) {
        setMonitoring(prepareMonitoring(response.data));
        tableKeyMonitoringCount.value++;
        if (tableKeyMonitoringCount.value > 2160) {
          tableKeyMonitoring.value = Date.now();
          tableKeyMonitoringCount.value = 0;
        }
      }
    })
    .catch((er) =>
      addScriptLog({
        message: `Ошибка получения мониторинга объектов TTMAllFacilitiesForm: ${er.response || er}`,
        facilityId: 0,
      })
    );
}
function prepareEvent(event, showCategory = true) {
  let result = null;
  if (event?.eventType) {
    result = event.eventType.name;
  }
  if (event?.eventType?.eventCategory && showCategory) {
    result = result
      ? `${result} (${event.eventType.eventCategory.name});`
      : event.eventType.eventCategory.name;
  }
  result = `${result} ${typeFormat.value(new Date(event.date), 'date-time')}`;
  return result;
}
function getFacility(item, name) {
  const result = { wellName: null, link: null };
  for (const element of struct.value) {
    if (item.facilityId === element.facility_id) {
      result.wellName = element[name];
      result.link = {
        node_type_id: element.node_type_id,
        facility_id: element.facility_id,
        facility_type_id: element.facility_type_id,
      };
      element.children.forEach((child) => {
        if (child.parent_flange_no_min == item.flangeNumber) {
          result.wellName = child[name];
          result.link = {
            node_type_id: child.node_type_id,
            facility_id: child.facility_id,
            facility_type_id: child.facility_type_id,
          };
        }
      });
    }
  }
  if (result.wellName === null) {
    for (const element of struct.value) {
      element.children.forEach((child) => {
        if (child.facility_id == item.facilityId) {
          result.wellName = child[name];
          result.link = {
            node_type_id: child.node_type_id,
            facility_id: child.facility_id,
            facility_type_id: child.facility_type_id,
          };
        }
      });
    }
  }
  return result;
}
function prepareMonitoring(data) {
  return data.map((item) => {
    const { wellName, link } = getFacility(item, 'facility_name');
    return {
      ...item,
      wellName,
      link,
      datePropertyLong: item.datePropertyLong
        ? typeFormat.value(new Date(item.datePropertyLong), 'date-time')
        : item.lastActiveEventDate
          ? typeFormat.value(new Date(item.lastActiveEventDate), 'date-time')
          : null,
      accumValueDay: item.isAccumValue ? item.liquidSum : item.liquidTDay,
      activeEvent: item.activeEvents?.length
        ? prepareEvent(item.activeEvents[0], false)
        : item.lastActiveEvent
          ? item.lastActiveEvent
          : '',
      activeEventsHint: item.activeEvents?.length
        ? item.activeEvents.map((event) => prepareEvent(event)).join('\n')
        : item.lastActiveEvent
          ? item.lastActiveEvent
          : '',
      rateM3Departure: item.rateM3Departure ? item.rateM3Departure.toFixed(2) : item.rateM3Departure,
      groupId: item.activeEvents?.length
        ? item.activeEvents[0].eventType?.groupId
        : item.rowStyleLastActiveEvent
          ? item.rowStyleLastActiveEvent
          : null,
    };
  });
}
function onChangeForms() {
  setMonitoring([]);
  columnsTemp.value = prepareColumnsTemp();
  headerRowsTemp.value = prepareHeaderRowsTemp();
}

function onExportExcel() {
  const data = DataTableMonitoring.value?.value || [];
  exportExcel({
    fileName: 'monitoring.xlsx',
    tableData: data,
    tableColumns: columnsTemp.value,
    tableHeader: headerRowsTemp.value,
  });
}

function getCellStyle(col, data) {
  return typeof col.cellStyle === 'function' ? col.cellStyle(data) : {};
}

function changeColumn(event) {
  columnsWell.value.forEach((column) => {
    const index = event.value.findIndex((item) => item == column.fieldHeader);
    if (index > -1) column.visible = true;
    else column.visible = false;
  });
  columnsTemp.value = prepareColumnsTemp();
  headerRowsTemp.value = prepareHeaderRowsTemp();
}
function rowClass(data) {
  switch (data.groupId) {
    case 2:
      return 'row-accessories-yellow';
    case 1:
    case 3:
      return 'row-accessories-green';
    case 4:
      return 'row-accessories-red';
    case 5:
      return 'row-accessories-orange';
    case 'FacilityNormal':
    case 'MeterNormal':
      return 'row-accessories-green';
    case 'MeterAlarm':
      return 'row-accessories-yellow';
    case 'TechAlarm':
      return 'row-accessories-red';
    case 'TechWarning':
      return 'row-accessories-orange';
    default:
      return 'row-accessories-gray';
  }
}

const properMonitoring = computed(() => {
  const mon = monitoring.value;
  if (mon?.length)
    fillSelfReference(mon, [
      { key: 'facilityName', name: 'facilityNames' },
      { key: 'wellName', name: 'wellNames' },
    ]);
  return mon;
});

form.value = forms.WELL;
let columns = [];
for (const column of columnsWell.value) {
  if (column.visible) {
    columns.push(column.field + column.header);
  }
}
columnsWell.value = columnsWell.value.map((item) => ({
  ...item,
  fieldHeader: item.field + item.header,
}));
currentColumns.value = columns;
columnsTemp.value = prepareColumnsTemp();
headerRowsTemp.value = prepareHeaderRowsTemp();
if (user.value.dept_id && user.value.dept_id !== 200000 && user.value.dept_id !== 269000) {
  delete forms.KOGS_DETAILS;
}
prepareFilters();

onMounted(() => {
  intervalLoadMonitoring.value = setInterval(() => {
    getValues();
  }, monitoringUpdate.value * 1000);
});

onBeforeUnmount(() => {
  clearInterval(intervalLoadMonitoring.value);
  setMonitoring([]);
});
</script>

<style scoped lang="scss">
::v-deep(.row-accessories-blue) {
  background-color: rgba(57, 26, 196, 0.425) !important;
}

::v-deep(.row-accessories-green) {
  background-color: #c0dcc0 !important;
}

::v-deep(.row-accessories-red) {
  background-color: #ff6c6c !important;
}

::v-deep(.row-accessories-yellow) {
  background-color: #fcfa98 !important;
}

::v-deep(.row-accessories-orange) {
  background-color: #f8d69c !important;
}

::v-deep(.row-accessories-gray) {
  background-color: #eeeeeebb !important;
}

.minimize {
  max-width: 35px;
  height: 30px;
}

.component-form {
  margin-top: 0.2rem
}
</style>
